/*
 * Algorithms for wayfinding:
 *
 * navigate - takes a startLocation and endLocation as strings and returns [WayfindingSegments]
 *
 */
import * as WayfindingSegment from './data-model/wayfinding-segment';

// GSO: from The Front Porch to AA Baggage Server all on dynamicgso-terminal-2
const _frontPorchToGate41 = [
    {
        levelId: 'dynamicgso-terminal-2',
        ordinalId: 'ordinal: 2',
        venueId: 'dynamicgso',
        coordinates: [
            [-79.93639, 36.10548],
            [-79.936363, 36.105457],
            [-79.93684, 36.105083],
            [-79.937087, 36.104891],
            [-79.937502, 36.10457],
            [-79.937541, 36.104602],
            [-79.937647, 36.104518],
        ],
        segmentType: 'walk',
        badges: [
            {
                entityId: '21',
                canonicalName: 'wayfinding.start',
                coordinates: [-79.93639, 36.10548],
            },
        ],
    },

    {
        levelId: 'dynamicgso-terminal-2',
        ordinalId: 'ordinal: 2',
        venueId: 'dynamicgso',
        coordinates: [
            [-79.937647, 36.104518],
            [-79.937499, 36.104399],
        ],
        segmentType: 'security',
        badges: [
            {
                entityId: '299',
                canonicalName: 'security',
                coordinates: [-79.937573, 36.1044585],
            },
        ],
    },

    {
        levelId: 'dynamicgso-terminal-2',
        ordinalId: 'ordinal: 2',
        venueId: 'dynamicgso',
        coordinates: [
            [-79.937499, 36.104399],
            [-79.937411, 36.104326],
            [-79.937265, 36.104438],
            [-79.936991, 36.10421],
            [-79.936962, 36.104232],
            [-79.936842, 36.104127],
            [-79.936791, 36.104167],
        ],
        segmentType: 'walk',
        badges: [
            {
                entityId: '65',
                canonicalName: 'wayfinding.end',
                coordinates: [-79.936791, 36.104167],
            },
        ],
    },
];

// GSO: from The Front Porch to AA Baggage Server starts on dynamicgso-terminal-2 and finishes on dynamicgso-terminal-1
const _frontPorchToAABaggage = [
    {
        levelId: 'dynamicgso-terminal-2',
        ordinalId: 'ordinal: 2',
        venueId: 'dynamicgso',
        coordinates: [
            [-79.93639, 36.10548],
            [-79.936363, 36.105457],
            [-79.936492, 36.105359],
            [-79.936431, 36.105305],
            [-79.936437, 36.105309],
            [-79.936459, 36.105291],
            [-79.936459, 36.105287],
        ],
        segmentType: 'walk',
        badges: [
            {
                entityId: '21',
                canonicalName: 'wayfinding.start',
                coordinates: [-79.93639, 36.10548],
            },
        ],
    },
    {
        levelId: 'dynamicgso-terminal-1',
        ordinalId: 'ordinal: 1',
        venueId: 'dynamicgso',
        segmentType: 'escalator',
        coordinates: [
            [-79.936561, 36.105207],
            [-79.936561, 36.105207],
        ],
        badges: [
            {
                entityId: '21',
                canonicalName: 'wayfinding.escalatordown',
                coordinates: [-79.93639, 36.10548],
            },
        ],
    },
    {
        levelId: 'dynamicgso-terminal-1',
        ordinalId: 'ordinal: 1',
        venueId: 'dynamicgso',
        segmentType: 'walk',
        coordinates: [
            [-79.936561, 36.105207],
            [-79.936577, 36.105198],
            [-79.936621, 36.105234],
            [-79.937441, 36.104592],
        ],
        badges: [
            {
                entityId: '103',
                canonicalName: 'wayfinding.end',
                coordinates: [-79.937441, 36.104592],
            },
        ],
    },
];

/*
 * Navigate from startLocation to endLocation
 * TODO: Wayfinding.navigate is entirely mocked data
 * @sig :: (String, String) -> [WayfindingSegment]
 */
const navigate = (startLocation, endLocation) => {
    switch (`${startLocation}|${endLocation}`) {
        case 'The Front Porch|Gate 41':
            return WayfindingSegment.fromArray(_frontPorchToGate41);
        case 'The Front Porch|AA Baggage':
            return WayfindingSegment.fromArray(_frontPorchToAABaggage);
        default:
            return [];
    }
};

export { navigate };
